// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zTZNVhMScTouQY9H7yiG{background:var(--background-primary-inverted-primary);cursor:pointer;border-radius:6px;align-items:center;height:32px;padding:0 0 0 8px;display:flex}.zTZNVhMScTouQY9H7yiG:hover{background:var(--background-neutral-subtle)}.T9pSG8lxXG8fDGb8YGw4{margin-right:8px}.Cz4vQL0dtQsap5sqRDfD{color:var(--content-primary-primary);white-space:nowrap;text-overflow:ellipsis;max-width:300px;font-size:13px;overflow:hidden}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item": `zTZNVhMScTouQY9H7yiG`,
	"item__avatar": `T9pSG8lxXG8fDGb8YGw4`,
	"itemAvatar": `T9pSG8lxXG8fDGb8YGw4`,
	"item__name": `Cz4vQL0dtQsap5sqRDfD`,
	"itemName": `Cz4vQL0dtQsap5sqRDfD`
};
export default ___CSS_LOADER_EXPORT___;
